import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { registerMaterialSvgIcons } from './material-svg-icons.registry';

export function materialIconsAppInitializerFactory(
  registry: MatIconRegistry,
  sanitizer: DomSanitizer,
): () => void {
  return () => registerMaterialSvgIcons(registry, sanitizer);
}
